import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IpbLoadingComponent } from './ipb-loading.component';
import { IdsLoadingModule } from '@ids/angular';

@NgModule({
	declarations: [IpbLoadingComponent],
	imports: [CommonModule, IdsLoadingModule],
	exports: [IpbLoadingComponent],
	providers: [],
})
export class IpbLoadingModule { }
